import { QueryClient } from "@tanstack/react-query";
import { lazy, Suspense, useEffect, useState } from "react";

const ReactQueryDevtoolsProduction = lazy(() =>
  import("@tanstack/react-query-devtools/production").then((d) => ({
    default: d.ReactQueryDevtools,
  })),
);
const GlobalForQueryDevTools = window as unknown as {
  toggleQueryDevTools: () => void;
};

export function QueryDevTools({ client }: { client: QueryClient }) {
  const [showDevtools, setShowDevtools] = useState(false);
  useEffect(() => {
    GlobalForQueryDevTools.toggleQueryDevTools = () => {
      setShowDevtools((prev) => !prev);
    };
  }, []);

  if (!showDevtools) return <></>;

  return (
    <Suspense fallback={<></>}>
      <ReactQueryDevtoolsProduction client={client} />
    </Suspense>
  );
}
